import styled from 'styled-components';
import PageTop from '../../components/pageTop/PageTop';
import { useEffect, useState } from 'react';
import { usePatternContext } from '../../../context/PatternContext';
import Result from './result/Result';
import PatternBox from './pattern/PatternBox';
import Menu from '../../components/menu/Menu';
import { Pattern1, Pattern2, Pattern3 } from './pattern/data';
import PatternService from '../../../service/Pattern';
import Footer from '../../components/footer/Footer';
import UserService from '../../../service/User';
import { useModal } from '../../../context/ModalContext';
import Description_Box from '../../components/description/Description';

const MyAlgorithm = () => {
  const [openMenu, setOpenMenu] = useState(false);
  const {
    setPIdx,
    isStep1Done,
    isStep2Done,
    isStep3Done,
    isAnalysisDone,
    setIsStep1Done,
    setIsStep2Done,
    setIsStep3Done,
    setIsAnalysisDone,
    patternInfo,
    isCheckAvaiable,
    pIdx,
    isEditMode,
    pattern1,
    pattern2,
    pattern3,
    setIsEditMode,
    setSelectedTab,
    setPattern1,
    setPattern2,
    setPattern3,
    selectedTab,
    setIsCheckAvaiable,
  } = usePatternContext();

  const resetPattern = () => {
    setIsStep1Done(false);
    setIsStep2Done(false);
    setIsStep3Done(false);
    setIsAnalysisDone(false);
    setIsEditMode(false);
    setSelectedTab('분석 기준');
    setPIdx(0);

    setPattern1({
      type: 'A',
      region: { sido: '', sigungu: '', emd: '' },
      itemStatus: '',
      useArea: [],
      multiUseArea: [],
      analysisPeriod: { start: '2022-01-01', end: '2024-12-31' },
      pnu: '',
    });
    setPattern2({
      saleProfit: 'A',
      hiddenValue: 'A',
      takeProfit: 'N',
      marketPrice: '',
      appraisalPoint: '',
      bidCount: '',
      oldAge: '',
      saleDays: '',
      investmentAmount: '평균 실투자금',
      enteredAmount: '',
    });
    setPattern3({
      specialConditionOption: 'C',
      hugCondition: 'N',
      tenantsOpposition: 'N',
      wageBond: 'N',
      resale: 'N',
      violatingBuilding: 'N',
      statutoryLandRights: 'N',
      graveSiteRights: 'N',
      lien: 'N',
    });
  };

  useEffect(() => {
    resetPattern();
    setIsStep2Done(false);
    setIsStep3Done(false);
  }, []);

  useEffect(() => {
    if (isEditMode) {
      setPattern1({
        type: 'A',
        region: {
          sido: patternInfo.ctp,
          sigungu: patternInfo.sig ?? '',
          emd: patternInfo.emd ?? '',
        },
        itemStatus: renderCategory(patternInfo.item_category),
        multiUseArea: [],
        useArea:
          patternInfo.zoning !== null ? patternInfo.zoning.split(',') : [],
        analysisPeriod: {
          start: patternInfo.start_date,
          end: patternInfo.end_date,
        },
        pnu: patternInfo.pnu,
      });
      setPattern2({
        saleProfit: patternInfo.margin,
        hiddenValue: patternInfo.hidden_value,
        takeProfit: patternInfo.profit,
        marketPrice: patternInfo.market_prc,
        appraisalPoint: patternInfo.appraisal_point,
        bidCount: patternInfo.bid_cnt,
        oldAge: patternInfo.elapsed_years,
        saleDays: patternInfo.sale_days,
        investmentAmount:
          patternInfo.investment_rate === null ? '평균 실투자금' : '직접입력',
        enteredAmount: patternInfo.investment_rate ?? '',
      });
      setPattern3({
        specialConditionOption: patternInfo.option,
        hugCondition: patternInfo.hug,
        tenantsOpposition: patternInfo.opposing_power,
        wageBond: patternInfo.wage_bond,
        resale: patternInfo.resale,
        violatingBuilding: patternInfo.violation_building,
        statutoryLandRights: patternInfo.statutory_superficies,
        graveSiteRights: patternInfo.tomb_base_right,
        lien: patternInfo.lien,
      });
    }
  }, [isEditMode, patternInfo]);

  const savePattern = async () => {
    const data = {
      analysisType: pattern1.type,
      pnu: pattern1.pnu,
      itemCategory: pattern1.itemStatus,
      startDate: pattern1.analysisPeriod.start,
      endDate: pattern1.analysisPeriod.end,
      zoning: pattern1.useArea.join(','),
      margin: pattern2.saleProfit,
      hiddenValue: pattern2.hiddenValue,
      profit: pattern2.takeProfit,
      marketPrc: pattern2.marketPrice === '' ? 'A' : pattern2.marketPrice,
      appraisalPoint:
        pattern2.appraisalPoint === '' ? 'A' : pattern2.appraisalPoint,
      bidCnt: pattern2.bidCount === '' ? 'A' : pattern2.bidCount,
      elapsedYears: pattern2.oldAge === '' ? 'A' : pattern2.oldAge,
      saleDays: pattern2.saleDays === '' ? 'A' : pattern2.saleDays,
      investmentRate:
        pattern2.investmentAmount === '평균 실투자금'
          ? null
          : Number(pattern2.enteredAmount),
      hug: pattern3.hugCondition,
      opposingPower: pattern3.tenantsOpposition,
      wageBond: pattern3.wageBond,
      resale: pattern3.resale,
      violationBuilding: pattern3.violatingBuilding,
      statutorySuperficies: pattern3.statutoryLandRights,
      tombBaseRight: pattern3.graveSiteRights,
      lien: pattern3.lien,
      option: pattern3.specialConditionOption,
    };

    try {
      const res = await PatternService.savePattern(data);
      setPIdx(res.data);
      setIsStep2Done(true);
      setIsStep3Done(true);
      setIsAnalysisDone(true);
    } catch (error) {
      console.error(error);
    }
  };

  const upDatePattern = async () => {
    try {
      const data = {
        analysisType: pattern1.type,
        pnu: pattern1.pnu,
        itemCategory: pattern1.itemStatus,
        startDate: pattern1.analysisPeriod.start,
        endDate: pattern1.analysisPeriod.end,
        zoning: pattern1.useArea.join(','),
        margin: pattern2.saleProfit,
        hiddenValue: pattern2.hiddenValue,
        profit: pattern2.takeProfit,
        marketPrc: pattern2.marketPrice === '' ? 'A' : pattern2.marketPrice,
        appraisalPoint:
          pattern2.appraisalPoint === '' ? 'A' : pattern2.appraisalPoint,
        bidCnt: pattern2.bidCount === '' ? 'A' : pattern2.bidCount,
        elapsedYears: pattern2.oldAge === '' ? 'A' : pattern2.oldAge,
        saleDays: pattern2.saleDays === '' ? 'A' : pattern2.saleDays,
        investmentRate:
          pattern2.investmentAmount === '평균 실투자금'
            ? null
            : Number(pattern2.enteredAmount),
        hug: pattern3.hugCondition,
        opposingPower: pattern3.tenantsOpposition,
        wageBond: pattern3.wageBond,
        resale: pattern3.resale,
        violationBuilding: pattern3.violatingBuilding,
        statutorySuperficies: pattern3.statutoryLandRights,
        tombBaseRight: pattern3.graveSiteRights,
        lien: pattern3.lien,
        option: pattern3.specialConditionOption,
      };
      const res = await PatternService.update(pIdx, data);
      if (res.status === 'success') {
        alert('수정되었습니다.');
        setIsEditMode && setIsEditMode(false);
        setIsAnalysisDone(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleReset = () => {
    if (selectedTab === '분석 기준') {
      setPattern1({
        type: 'A',
        region: { sido: '', sigungu: '', emd: '' },
        itemStatus: '',
        useArea: [],
        multiUseArea: [],
        analysisPeriod: { start: '2022-01-01', end: '2024-12-31' },
        pnu: '',
      });
      setIsCheckAvaiable(false);
    } else if (selectedTab === '핵심 알고리즘') {
      setPattern2({
        saleProfit: 'A',
        hiddenValue: 'A',
        takeProfit: 'N',
        marketPrice: '',
        appraisalPoint: '',
        bidCount: '',
        oldAge: '',
        saleDays: '',
        investmentAmount: '평균 실투자금',
        enteredAmount: '',
      });
    } else {
      setPattern3({
        specialConditionOption: 'C',
        hugCondition: 'N',
        tenantsOpposition: 'N',
        wageBond: 'N',
        resale: 'N',
        violatingBuilding: 'N',
        statutoryLandRights: 'N',
        graveSiteRights: 'N',
        lien: 'N',
      });
    }
  };
  const { modalDispatch } = useModal();
  return (
    <Container>
      <PageTop text={'나만의 알고리즘 만들기'} setOpenMenu={setOpenMenu} />
      <StepWrapper isAnalysisDone={isAnalysisDone}>
        <StepBox>
          {selectedTab === '핵심 알고리즘' ||
          selectedTab === '특수 알고리즘' ||
          isAnalysisDone ? (
            <img src="assets/images/icon/check-on.svg" />
          ) : (
            <StepContent isDone={true}>1</StepContent>
          )}
          <div
            style={{
              color:
                selectedTab === '핵심 알고리즘' ||
                selectedTab === '특수 알고리즘'
                  ? '#008AFF'
                  : 'rgba(55, 56, 60, 0.16)',
            }}
          >
            •••
          </div>
          {selectedTab === '특수 알고리즘' || isStep2Done ? (
            <img src="assets/images/icon/check-on.svg" />
          ) : (
            <StepContent
              isDone={selectedTab === '특수 알고리즘' || isStep2Done}
            >
              2
            </StepContent>
          )}
          <div
            style={{
              color:
                selectedTab === '특수 알고리즘'
                  ? '#008AFF'
                  : 'rgba(55, 56, 60, 0.16)',
            }}
          >
            •••
          </div>
          {isStep3Done ? (
            <img src="assets/images/icon/check-on.svg" />
          ) : (
            <StepContent isDone={selectedTab === '특수 알고리즘'}>
              3
            </StepContent>
          )}
        </StepBox>
        <div>
          <span>
            {isAnalysisDone
              ? '알고리즘 분석 결과'
              : selectedTab === '특수 알고리즘'
                ? '특수 알고리즘 만들기'
                : selectedTab === '핵심 알고리즘'
                  ? '핵심 알고리즘 만들기'
                  : '분석 기준 만들기'}
          </span>
        </div>
      </StepWrapper>
      <Inner>
        {isAnalysisDone ? (
          <Result setIsEditMode={setIsEditMode} />
        ) : (
          <>
            <Description_Box
              desc1="내 투자 성향에 맞춰 직접 만드는 맞춤형 경매 공식!"
              desc2={`과거 경매 데이터 분석으로 나만의 
수익공식(승률, 수익률, 시세차익 알고리즘)을 설계합니다.
직접 설정, 직접 분석, 나만의 전략 생성!`}
            />
            <PatternBox isEditMode={isEditMode} />
          </>
        )}
        <Footer />
      </Inner>
      {!isAnalysisDone && (
        <SelectedArea>
          <BottomButtonBox>
            <ResetButton onClick={handleReset}>
              <img src="/assets/images/icon/reload-gray.svg" alt="" />
              <span>초기화</span>
            </ResetButton>
            {!(selectedTab === '특수 알고리즘' && isCheckAvaiable) && (
              <NextButton
                onClick={() => {
                  if (selectedTab === '분석 기준' && isCheckAvaiable) {
                    setSelectedTab('핵심 알고리즘');
                    setIsStep1Done(true);
                  } else if (
                    selectedTab === '핵심 알고리즘' &&
                    isCheckAvaiable
                  ) {
                    setSelectedTab('특수 알고리즘');
                    setIsStep2Done(true);
                  } else if (
                    selectedTab === '특수 알고리즘' &&
                    isCheckAvaiable
                  ) {
                    // setIsStep3Done(true);
                  }
                }}
                disabled={!isCheckAvaiable && selectedTab !== '특수 알고리즘'}
                style={{
                  backgroundColor:
                    isCheckAvaiable && selectedTab !== '특수 알고리즘'
                      ? '#eaf2fe'
                      : '#F7F7F8',
                  color:
                    isCheckAvaiable && selectedTab !== '특수 알고리즘'
                      ? '#008aff'
                      : 'rgba(55, 56, 60, 0.16)',
                }}
              >
                다음
              </NextButton>
            )}
            <AnalyzeButton
              disabled={!isCheckAvaiable}
              style={{
                backgroundColor: isCheckAvaiable ? '#008aff' : '#F7F7F8',
                color: isCheckAvaiable ? '#fff' : 'rgba(55, 56, 60, 0.16)',
              }}
              onClick={async () => {
                if (await UserService.userGrade()) {
                  isEditMode ? upDatePattern() : savePattern();
                } else {
                  modalDispatch('MC1');
                }
              }}
            >
              결과보기
            </AnalyzeButton>
          </BottomButtonBox>
        </SelectedArea>
      )}
      {openMenu && <Menu page="myAlgorithm" setOpenMenu={setOpenMenu} />}
    </Container>
  );
};
export default MyAlgorithm;

const renderCategory = (category: string) => {
  if (
    category ===
    '아파트,주택,단독주택,연립주택,다가구(원룸등),다세대(빌라),근린주택,오피스텔'
  ) {
    return '주거용전체';
  } else if (
    category ===
    '근린생활시설,근린시설,근린상가,사무실,지식산업센터,아파트형공장,창고,공장,숙박시설,숙박(콘도등),목욕탕,노유자시설,문화및집회시설,종교시설,의료시설,교육연구시설,교육시설,장례관련시설,농가관련시설,주유소,주유소(위험물),자동차관련시설,분뇨쓰레기처리'
  ) {
    return '상업/산업용전체';
  } else if (
    category ===
    '대지,답,전,농지,과수원,임야,잡종지,도로,주차장,묘지,목장용지,공장용지,창고용지,기타'
  ) {
    return '토지전체';
  } else return category;
};

const BottomButtonBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;
const ResetButton = styled.button`
  padding: 7px 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: 1px solid #e1e2e4;
  color: #616161;
  background-color: #fff;
  cursor: pointer;
  font-family: Spoqa Han Sans Neo;
  font-weight: 400;
  font-size: 12px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
  text-wrap: nowrap;
`;
const NextButton = styled.button`
  padding-block: 12px;
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: none;
  font-size: 16px;
  font-weight: 500;
  line-height: 145%;
  color: #008aff;
  background-color: #eaf2fe;
  cursor: pointer;
`;

const AnalyzeButton = styled.button`
  padding-block: 12px;
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: none;
  font-size: 16px;
  font-weight: 500;
  line-height: 145%;
  color: #fff;
  background-color: #008aff;
  cursor: pointer;
`;

const SelectedArea = styled.div`
  position: sticky;
  bottom: 0;
  z-index: 1000;
  background-color: #fff;
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 16px;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 16px 24px;
`;
const SelectedBox = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  gap: 11px;
  flex-wrap: wrap;
`;
const SelectedItem = styled.span`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
  font-size: 12px;
  font-weight: 500;
  color: #616161;
`;

interface StepContentProps {
  isDone?: boolean;
}
const StepContent = styled.div<StepContentProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 22px;
  height: 22px;
  border: 1px solid #e5e8ea;
  border-radius: 9999px;
  color: ${(props) => (props.isDone ? '#fff' : 'rgba(55, 56, 60, 0.16)')};
  background-color: ${(props) => (props.isDone ? '#008AFF' : '#fff')};
  border: ${(props) => (props.isDone ? '' : '1px solid #E5E8EA')};
`;

const StepBox = styled.div`
  //   width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 8px;
`;

interface StepWrapperProps {
  isAnalysisDone: boolean;
}

const StepWrapper = styled.div<StepWrapperProps>`
  // position: sticky;
  position: ${(props) => (props.isAnalysisDone ? 'static' : 'sticky')};
  top: 55px;
  z-index: 1000;
  background-color: #fff;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 16px;
  padding-top: 8px;
  color: rgba(55, 56, 60, 0.16);
  font-size: 12px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  line-height: 17.4px;
  word-wrap: break-word;
  span {
    color: #008aff;
    font-size: 14px;
    font-family: Spoqa Han Sans Neo;
    font-weight: 500;
    line-height: 20.3px;
    word-wrap: break-word;
  }
`;

const Inner = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #f7f8fc;
  // padding: 24px 16px 145px;
`;
const Container = styled.div`
  max-width: 900px;
  min-height: 100vh;
  margin: 0 auto;
  box-shadow: 0 0 20px hsla(0, 0%, 51%, 0.15);
  position: relative;
`;
